<div class="detail-header">
  <div class="detail-header__content">
    <div class="detail-header__main">
      <!-- Logo -->
      <div class="detail-header__logo__outer">
        <div
          class="detail-header__logo__inner"
          [ngStyle]="{
            'background-image':
              'url(' +
              (((cruise$ | async)?.tourOperator.id === CruiseTopId.CARNIVAL)
                ? 'assets/images/top/183-183.png'
                : ((cruise$ | async)?.tourOperator.id | imageByCode : 'top')) +
              ')'
          }"
        ></div>
      </div>

      <div class="detail-header__info">
        <!-- Nome crociera -->
        <h1 class="detail-header__accomodation">
          <span>{{
            (cruise$ | async)?.name?.toString()?.replaceAll(",", ", ")
          }}</span>
        </h1>
        <!-- Destinazione -->
        <span class="detail-header__destination d-block mb-2">
          {{ (cruise$ | async)?.parentName }},
          {{ (cruise$ | async)?.selectedSolution?.days }} giorni
        </span>
      </div>
    </div>
    <div class="detail-header__price d-block d-md-none">
      <div class="detail-header__price-deets">
        <h4 class="mb-0">
          da {{ (cruise$ | async)?.selectedSolution.price }} €
        </h4>
        <p class="mb-0 text-muted fs-xs">
          Prezzo per {{ passengers === 1 ? '' : passengers }} {{ passengers >= 2 ? ' passeggeri' : ' persona' }}  (tasse e costi inclusi)
        </p>
      </div>
    </div>
    <!-- biscotto mobile (sarà sostituito da componente summary) -->

    <!-- <div class="detail-header__price">
      <div class="detail-header__price-deets">
        <span>€ {{(cruise$ | async)?.selectedSolution.price}} <i class="g-icon-info-rounded"></i></span>
        <span>Prezzo per persona</span>
        <span>(tasse e costi inclusi)</span>
      </div>
      <div class="button-wrapper">
        <a dynamicNavigation [href]="bookingUrl"
          class="btn btn--brand-color-03 btn--mobile detail-header__price-cta text-left">
          <span>Prosegui</span>
          <i class="g-icon-chevron-right-circle"></i>
        </a>
        <div *ngIf="!(this.isWidget$ | async) && !(this.isB2B$ | async)" class="fb-share-button"
          data-href="{{location}}" data-size="large" data-layout="button">
          <a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u={{location}};src=sdkpreparse"
            class="fb-xfbml-parse-ignore btn btn--blue w-100 text-left custom-fb__share-button">
            <span>
              <ion-icon name="logo-facebook"></ion-icon>
              <span class="btn__uppercase">
                Condividi
              </span>
            </span>
          </a>
        </div>
      </div>
    </div> -->
  </div>
</div>

<!-- <div class="detail-header">
  <div class="detail-header__content">
    <div class="detail-header__main">
      <div class="detail-header__logo-to"
           [ngStyle]="{'background-image': 'url(' + ((cruise$ | async)?.tourOperator.id | imageByCode:'top')+ ')'}"></div>
      <div class="detail-header__title">
        <h1 class="h1">{{(cruise$ | async)?.name}}</h1>
        <span>{{(cruise$ | async)?.parentName}}, {{(cruise$ | async)?.selectedSolution.days}} giorni</span>
      </div>
    </div>
    <div class="detail-header__price">
      <div class="detail-header__price-deets">
        <span>€ {{(cruise$ | async)?.selectedSolution.price}} <i class="g-icon-info-rounded"></i></span>
        <span>Prezzo per persona</span>
        <span>(tasse e costi inclusi)</span>
      </div>
      <div class="button-wrapper">
        <a dynamicNavigation [href]="bookingUrl"
           class="btn btn--brand-color-03 btn--mobile detail-header__price-cta text-left">
          <span>Prosegui</span>
          <i class="g-icon-chevron-right-circle"></i>
        </a>
        <div *ngIf="!(this.isWidget$ | async) && !(this.isB2B$ | async)" class="fb-share-button" data-href="{{location}}"
          data-size="large" data-layout="button">
          <a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u={{location}};src=sdkpreparse"
            class="fb-xfbml-parse-ignore btn btn--blue w-100 text-left custom-fb__share-button">
            <span>
              <ion-icon name="logo-facebook"></ion-icon>
              <span class="btn__uppercase">
                Condividi
              </span>
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div> -->
